import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import Button1 from "../../form/Button1";
import { useSelector } from "react-redux";
import getAdminTeamMembers from "../../../controllers/settings/adminTeam/getTeamMembers";
import { ComparePAX } from "./ComparePAX";
import { PriceBreakdown } from "./PriceBreakdown";
import { enqueueSnackbar } from "notistack";
import setChangeFee from "../../../controllers/booking/postTicketing/change/setChangeFee";
import ManualChange from "./ManualChange";
// import selectFlightChange from "../../../controllers/booking/postTicketing/change/selectFlightChange";
import setSelectedSegment from "../../../controllers/booking/postTicketing/change/setSelectedSegment";
import { Modal3 } from "../../DIsplay/Modal/Modal3";
import ExpiryInput from "./ExpiryInput";
import CommonTextAreaInput from "../../common/inputs/CommonTextAreaInput";
import { applicableFee } from "../../../utils/booking/changeFee";
import { formatMoney } from "../../../features/utils/formatMoney";

export default function ManualChangeQuote({ data, reload, close }) {
  const [handleOption, setHandleOption] = useState("direct");
  const [details, setDetails] = useState(data?.remark || "");
  const [staffs, setStaffs] = useState([]);
  const [loadings, setLoadings] = useState({
    fetchStaff: false,
    submit: false,
  });

  // NOTE: PriceBreakdown will callback with array rows
  const [feeData, setFeeData] = useState([
    {
      passengerId: 1,
      type: "Adt",
      ticketDifference: 0,
      changePrice: 0,
      penaltyFee: 0,
      edit: false,
    },
  ]);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [paymentDeadline, setPaymentDeadline] = useState(
    moment().add(3, "hours").toISOString(),
  );

  const [travelers, setTravelers] = useState([]);

  const {
    paymentSettings: { fees },
  } = useSelector((state) => state.paymentSettings);

  const flightsFromSelected = (() => {
    if (data?.selectedOffer) {
      try {
        const offer = JSON.parse(data?.selectedOffer);
        if (!offer) return;
        const segments = offer?.directions?.flatMap(
          (direction, directionIndex) =>
            direction?.map((segment) => {
              return {
                ...segment,
                segment: String(directionIndex + 1),
                offerId: offer?.id,
                airline:
                  segment?.airline?.marketing || segment?.airline?.operating,
                airlineImage: segment?.airline?.image?.url,
                airlineName: segment?.airline?.image?.description,
                arrivalAirport: segment?.arrival?.airport,
                arrivalDate: segment?.arrival?.date,
                arrivalLocation: segment?.arrival?.location,
                arrivalLocationName: segment?.arrival?.city,
                arrivalTerminal: segment?.arrival?.terminal,
                arrivalTime: segment?.arrival?.time,
                departureAirport: segment?.departure?.airport,
                departureDate: segment?.departure?.date,
                departureLocation: segment?.departure?.location,
                departureLocationName: segment?.departure?.city,
                departureTerminal: segment?.departure?.terminal,
                departureTime: segment?.departure?.time,
              };
            }),
        );
        return segments;
      } catch (error) {
        return [];
      }
    }
    return [];
  })();

  const selectedSegmentsFromOrder = Array.isArray(data?.selectedSegment)
    ? data.selectedSegment.map((segment, index) => ({
        ...segment,
        segment: segment?.segment || String(index + 1),
        airline: segment?.airline?.marketing || segment?.airline?.operating,
        airlineImage: segment?.airline?.image?.url,
        airlineName: segment?.airline?.image?.description,
        arrivalAirport: segment?.arrivalAirport || segment?.arrival?.airport,
        arrivalDate: segment?.arrivalDate || segment?.arrival?.date,
        arrivalLocation: segment?.arrivalLocation || segment?.arrival?.location,
        arrivalLocationName:
          segment?.arrivalLocationName || segment?.arrival?.city,
        arrivalTerminal: segment?.arrivalTerminal || segment?.arrival?.terminal,
        arrivalTime: segment?.arrivalTime || segment?.arrival?.time,
        departureAirport:
          segment?.departureAirport || segment?.departure?.airport,
        departureDate: segment?.departureDate || segment?.departure?.date,
        departureLocation:
          segment?.departureLocation || segment?.departure?.location,
        departureLocationName:
          segment?.departureLocationName || segment?.departure?.city,
        departureTerminal:
          segment?.departureTerminal || segment?.departure?.terminal,
        departureTime: segment?.departureTime || segment?.departure?.time,
      }))
    : [];

  const flights = selectedSegmentsFromOrder?.length
    ? selectedSegmentsFromOrder
    : data?.selectedOffer
      ? flightsFromSelected
      : data?.flightBooking
          ?.at(0)
          ?.flights?.filter((flight) =>
            data?.directionsToChange?.includes(flight?.segmentRef),
          )
          ?.map((obj, i) => {
            const newSeg = data?.newSegment?.find(
              (ob) => ob?.segmentRef === obj?.segmentRef,
            );
            return {
              ...obj,
              departureDate: moment(
                newSeg?.departure?.date ||
                  data?.newDirections?.at(Number(obj?.segment) - 1)?.departure,
              )?.format("YYYY-MM-DD"),
              arrivalDate: moment(
                newSeg?.arrival?.date ||
                  data?.newDirections?.at(Number(obj?.segment) - 1)?.departure,
              )?.format("YYYY-MM-DD"),
              departureTime: newSeg?.departure?.time || obj?.departureTime,
              arrivalTime: newSeg?.arrival?.time || obj?.arrivalTime,
            };
          }) || [];

  const [newSegment, setNewSegment] = useState({
    flights,
    destinations: data?.flightBooking
      ?.at(0)
      ?.destinations?.filter((_, i) =>
        flights?.find((flight) => Number(flight?.segment) - 1 === i),
      )
      ?.map((obj, i) => {
        return {
          ...obj,
          departureDate: moment(
            flights?.find((flight) => Number(flight?.segment) - 1 === i)
              ?.departureDate,
          )?.format("YYYY-MM-DD"),
        };
      }),
  });

  useEffect(() => {
    if (data) loadStaff();
    // eslint-disable-next-line
  }, [data]);

  async function loadStaff() {
    setLoadings({ ...(loadings || {}), fetchStaff: true });
    const res = await getAdminTeamMembers();
    setLoadings({ ...(loadings || {}), fetchStaff: false });
    if (res.return) {
      setStaffs(res?.data?.data || []);
    }
  }

  async function handleManual() {
    const payload = {
      changeOrderId: data?._id,
      ...newSegment,
      travelers: travelers || [],
    };

    const newSegmentObject = payload?.flights?.map((obj) => ({
      ...obj,
      _id: undefined,
      stops: undefined,
      aircraftCode: obj?.aircraftCode,
      flightNumber: obj?.flightNumber,
      departure: {
        time: moment(obj?.departureTime, "hh:mm A").format("HH:mm"),
        date: moment(obj?.departureDate).format("YYYY-MM-DD"),
        location: obj?.departureLocation,
        airport: obj?.departureAirport,
        city: obj?.departureCity,
      },
      arrival: {
        time: moment(obj?.arrivalTime, "hh:mm A").format("HH:mm"),
        date: moment(obj?.arrivalDate).format("YYYY-MM-DD"),
        location: obj?.arrivalLocation,
        airport: obj?.arrivalAirport,
        city: obj?.arrivalCity,
      },
      cabinClass: obj?.cabinClass,
      bookingClass: obj?.bookingClass,
      segmentRef: obj?.segmentRef,
      airline: {
        image: { url: obj?.airlineImage, description: obj?.airlineName },
        marketing: obj?.airline,
        operating: obj?.airline,
      },
      id: data?._id,
    }));

    setLoadings({ ...loadings, save: true });
    const res = await setSelectedSegment({
      changeOrderId: data?._id,
      segments: newSegmentObject,
    });
    setLoadings({ ...loadings, save: false });

    if (res.return) {
      close && close();
      window.location.reload();
      return true;
    }
    enqueueSnackbar(res.msg, { variant: "error" });
    return false;
  }

  async function handleSubmit() {
    const priceBreakdown = (feeData || []).map((obj) => {
      const { edit, ...rest } = {
        ...obj,
        passengerId: (obj?.passengerId || "")?.toString(),
        changePrice: Number(obj?.changePrice || 0),
        ticketDifference: Number(obj?.ticketDifference || 0),
        penaltyFee: Number(obj?.penaltyFee || 0),
      };
      return rest;
    });

    const reqBody = {
      changeOrderId: data?._id,
      remark: details,
      priceBreakdown,
      paymentDeadline,
    };

    setLoadings({ ...loadings, submit: true });
    const res = await setChangeFee(reqBody);
    setLoadings({ ...loadings, submit: false });

    if (res.return) {
      enqueueSnackbar("Quote Complete.", { variant: "success" });
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  function handlePriceChange(next) {
    setFeeData(next);
  }

  // ✅ show bottom actions ONLY if each passenger has at least one of the 3 > 0
  const canShowBottomActions = useMemo(() => {
    const arr = feeData || [];
    if (!arr.length) return false;
    return arr.every(
      (p) =>
        Number(p?.changePrice || 0) > 0 ||
        Number(p?.ticketDifference || 0) > 0 ||
        Number(p?.penaltyFee || 0) > 0,
    );
  }, [feeData]);

  // ✅ Total charge for all passengers (same math as PriceBreakdown)
  const totalChargeAllPassengers = useMemo(() => {
    const arr = feeData || [];
    if (!arr.length) return 0;

    const totalPayable = arr.reduce(
      (acc, cur) =>
        acc +
        Number(cur?.changePrice || 0) +
        Number(cur?.penaltyFee || 0) +
        Number(cur?.ticketDifference || 0),
      0,
    );

    const fee =
      data?.changeRequest === "PassengerInfo"
        ? fees?.changePassengerDetailFee
        : fees?.reIssueFee;

    const serviceChargeFee = applicableFee(totalPayable, fee);
    const totalFee = serviceChargeFee * (arr.length || 1);

    return totalPayable + totalFee;
  }, [feeData, fees, data?.changeRequest]);

  let title = "PAX Change";
  if (data?.newSegment?.length) title = "Date Change";

  return (
    <div className="flex flex-col gap-4 max-h-[80vh] overflow-scroll scroll-hide">
      {data?.changeRequest === "PassengerInfo" ? (
        <ComparePAX
          data={{
            previous: data?.flightBooking
              ?.at(0)
              ?.travelers?.find(
                (obj) => obj?.id === data?.passengerInfo?.at(0)?.id,
              ),
            newData: data?.passengerInfo?.at(0),
          }}
        />
      ) : (
        <ManualChange
          callback={reload}
          {...{ data, newSegment, setNewSegment, flights }}
        />
      )}

      <PriceBreakdown data={data} callback={handlePriceChange} />

      <ExpiryInput callback={(d) => setPaymentDeadline(d)} />

      <CommonTextAreaInput
        label="Remarks"
        value={details}
        onChange={setDetails}
      />

      <Modal3
        open={openConfirm}
        setOpen={() => setOpenConfirm(false)}
        title="Confirm Quote"
      >
        <div className="flex flex-col gap-4 p-10">
          <div className="text-lg pb-4">
            Are you sure you want to confirm this quote?
          </div>
          <div className="flex gap-4">
            <div>
              <Button1 onClick={() => setOpenConfirm(false)} variant="outlined">
                Cancel
              </Button1>
            </div>
            <Button1 loading={loadings?.submit} onClick={handleSubmit}>
              Confirm
            </Button1>
          </div>
        </div>
      </Modal3>

      {/* ✅ Sticky bottom actions (same UI style as RefundQuote) */}
      {canShowBottomActions ? (
        <div className="sticky bottom-0 -mx-4 mt-2 border-t border-gray-200 bg-white px-4 py-3">
          <div className="flex items-center justify-between gap-3">
            {/* Left: total charge */}
            <div className="flex flex-col">
              <div className="text-xs text-gray-500">Total Charge</div>
              <div className="text-base font-semibold text-gray-900">
                -{formatMoney(totalChargeAllPassengers)}
              </div>
            </div>

            {/* Right: actions */}
            <div className="flex items-center justify-end gap-3">
              {/* Cancel */}
              <button
                type="button"
                onClick={() => close && close()}
                className="
                  h-10 rounded-lg px-4
                  border border-gray-400
                  text-sm font-medium text-gray-700 hover:text-gray-900
                "
              >
                Cancel
              </button>

              {/* Save */}
              <button
                type="button"
                disabled={loadings?.save}
                onClick={handleManual}
                className={`
                  h-10 rounded-lg px-4
                  border border-gray-200
                  text-sm font-semibold
                  ${
                    loadings?.save
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  }
                `}
              >
                {loadings?.save ? "Saving..." : "Save"}
              </button>

              {/* Confirm */}
              <button
                type="button"
                disabled={loadings?.submit}
                onClick={() => setOpenConfirm(true)}
                className={`
                  h-10 rounded-lg px-5
                  text-sm font-semibold text-white
                  ${
                    loadings?.submit
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-primary1 hover:opacity-90"
                  }
                `}
              >
                Confirm quote
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
